import IAPIResult from "models/IAPIResult";
import { IHRAOverviewReportResult } from "models/reports/IHRAOverviewReport";
import { IOpportunitiesReportResult } from "models/reports/IOpportunitiesReport";
import { fetchGetAsync } from "utilities/Fetch";

const SERVICE_PATH = "Reporting";

export default class ReportService {
    static async OpportunitiesAsync(accessToken: string, startDate: string, endDate: string): Promise<IOpportunitiesReportResult | null> {
        const result: IAPIResult<IOpportunitiesReportResult> =
            await fetchGetAsync<IAPIResult<IOpportunitiesReportResult>>(
                `/api/${SERVICE_PATH}/opportunities`,
                { startDate, endDate },
                accessToken);

        return result.success ? result.data : null;
    }

    static async HRAOverviewAsync(accessToken: string, startDate: string, endDate: string): Promise<IHRAOverviewReportResult | null> {
        const result: IAPIResult<IHRAOverviewReportResult> =
            await fetchGetAsync<IAPIResult<IHRAOverviewReportResult>>(
                `/api/${SERVICE_PATH}/hraOverview`,
                { startDate, endDate },
                accessToken);

        return result.success ? result.data : null;
    }
}